import { createContext } from 'react';
import { AdvertDetailContextType } from '#advertDetail/contexts/AdvertDetailContextType';

const AdvertDetailContext = createContext<AdvertDetailContextType>(null);

export { AdvertDetailContext };
